<div class="guide-dialog">
  <div class="guide-header">
    <h2
      id="add-home-screen-guide-title"
      class="guide-title"
    >
      {{ 'AddHomeScreenGuide.Title' | translate }}
    </h2>

    <p class="guide-subtitle">
      {{ 'AddHomeScreenGuide.Subtitle' | translate }}
    </p>
  </div>

  <ol class="guide-steps">
    @for (step of steps; track step.number) {
      <li class="guide-step">
        <span class="guide-step-number">{{ step.number }}</span>

        <div class="guide-step-content">
          <h3 class="guide-step-title">{{ step.titleKey | translate }}</h3>

          <p class="guide-step-description">
            {{ step.descriptionKey | translate }}
          </p>

          @if (step.tiles.length) {
            <div class="guide-tiles">
              @for (tile of step.tiles; track tile.icon) {
                <div class="guide-tile">
                  <ng-icon
                    [name]="tile.icon"
                    aria-hidden="true"
                  ></ng-icon>

                  <span class="guide-tile-label">
                    {{ tile.labelKey | translate }}
                  </span>
                </div>
              }
            </div>
          }
        </div>
      </li>
    }
  </ol>

  <div class="guide-info-box">
    <div class="guide-info-title">
      <ng-icon
        name="matInfo"
        aria-hidden="true"
      ></ng-icon>
      {{ 'AddHomeScreenGuide.CantFindTitle' | translate }}
    </div>

    <p class="guide-info-text">
      {{ 'AddHomeScreenGuide.CantFindBefore' | translate }}
      <ng-icon
        name="matMoreVert"
        aria-hidden="true"
      ></ng-icon>
      {{ 'AddHomeScreenGuide.CantFindBetween' | translate }}
      <ng-icon
        name="matIosShare"
        aria-hidden="true"
      ></ng-icon>
      {{ 'AddHomeScreenGuide.CantFindAfter' | translate }}
    </p>
  </div>

  <button
    type="button"
    class="btn btn-primary w-100 mt-auto text-uppercase fw-bold"
    (click)="close()"
  >
    {{ 'AddHomeScreenGuide.GotIt' | translate }}
  </button>
</div>
